import React, { createContext, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
export const GlobalContext = createContext();

export const GlobalProvider = (props) => {
  let navigate = useNavigate();
  const dataRadio = {
    pilihan: [
      { text: 'Open', value: 0 },
      { text: 'Closed', value: 1 },
    ],
  };

  const [selected, setSelected] = useState(0);
  const [user, setUser] = useState('undefined');
  const [arr, setArr] = useState([]);
  const [arrJob, setArrJob] = useState([]);
  const [fetchStatus, setFetchStatus] = useState(true);
  const [currentId, setcurrentId] = useState(-1);

  const [input, setInput] = useState({
    title: '',
    job_description: '',
    job_qualification: '',
    job_type: '',
    job_tenure: '',
    company_name: '',
    company_image_url: '',
    company_city: '',
    salary_min: '',
    salary_max: '',
    job_status: '',
  });

  function logouthandler() {
    Cookies.remove('token');
    Cookies.remove('user');
    window.alert('Silahkan login kembali!');
    navigate('/login');
  }

  const renderData = () => {
    axios
      .get('https://dev-example.sanbercloud.com/api/job-vacancy')
      .then((res) => {
        const tempArr = res.data.data.map((el) => {
          //   console.log(el);
          return el;
        });
        setArrJob(tempArr);
        setArr(tempArr);
      })
      .catch((e) => console.log(e));
    setFetchStatus(false);
  };

  const showContentTable = (desc) => {
    if (desc === null) {
      return 'Deskripsi kosong';
    }
    return desc.length > 15 ? desc.slice(0, 15 - 1) + '...' : desc;
  };

  const handleRadioButton = (event) => {
    setSelected(event.target.value);
  };

  const handleInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    if (name === 'title') {
      setInput({ ...input, title: value });
    } else if (name === 'job_description') {
      setInput({ ...input, job_description: value });
    } else if (name === 'job_qualification') {
      setInput({ ...input, job_qualification: value });
    } else if (name === 'job_type') {
      setInput({ ...input, job_type: value });
    } else if (name === 'job_tenure') {
      setInput({ ...input, job_tenure: value });
    } else if (name === 'company_name') {
      setInput({ ...input, company_name: value });
    } else if (name === 'company_image_url') {
      setInput({ ...input, company_image_url: value });
    } else if (name === 'company_city') {
      setInput({ ...input, company_city: value });
    } else if (name === 'salary_min') {
      setInput({ ...input, salary_min: value });
    } else if (name === 'salary_max') {
      setInput({ ...input, salary_max: value });
    } else if (name === 'job_status') {
      setInput({ ...input, job_status: value });
    }
  };

  const handleDelete = (event) => {
    const iddel = parseInt(event.target.value);
    const token = String(Cookies.get('token'));
    console.log(token);
    axios
      .delete(`https://dev-example.sanbercloud.com/api/job-vacancy/${iddel}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log(response);
        setFetchStatus(true);
      });
  };

  const handleDetail = (event) => {
    const id = parseInt(event.target.value);
    navigate(`/job/${id}`);
    setFetchStatus(true);
  };

  const handleEdit = (event) => {
    const id = parseInt(event.target.value);
    setcurrentId(id);
    navigate(`/dashboard/list-job-vacancy/form/edit/${id}`);
    setFetchStatus(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let {
      title,
      job_description,
      job_qualification,
      job_type,
      job_tenure,
      company_name,
      company_image_url,
      company_city,
      salary_min,
      salary_max,
      job_status,
    } = input;
    console.log(input);

    if (currentId === -1) {
      axios
        .post(
          'https://dev-example.sanbercloud.com/api/job-vacancy',
          {
            title,
            job_description,
            job_qualification,
            job_type,
            job_tenure,
            company_name,
            company_image_url,
            company_city,
            salary_min,
            salary_max,
            job_status,
          },
          { headers: { Authorization: 'Bearer ' + Cookies.get('token') } }
        )
        .then((response) => {
          console.log(response);
          setFetchStatus(true);
          navigate('/dashboard/list-job-vacancy');
        });
    } else {
      axios
        .put(
          `https://dev-example.sanbercloud.com/api/job-vacancy/${currentId}`,
          {
            title,
            job_description,
            job_qualification,
            job_type,
            job_tenure,
            company_name,
            company_image_url,
            company_city,
            salary_min,
            salary_max,
            job_status,
          },
          { headers: { Authorization: 'Bearer ' + Cookies.get('token') } }
        )
        .then((response) => {
          console.log(response);
          setFetchStatus(true);
          navigate('/dashboard/list-job-vacancy');
        });
    }
    setcurrentId(-1);
    setInput({
      title: '',
      job_description: '',
      job_qualification: '',
      job_type: '',
      job_tenure: '',
      company_name: '',
      company_image_url: '',
      company_city: '',
      salary_min: '',
      salary_max: '',
      job_status: '',
    });
  };

  const showStatus = (status) => {
    if (status === 1) {
      return 'Dibuka';
    } else if (status === 0) {
      return 'Ditutup';
    }
  };

  const showFormattedDate = (date) => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Date(date).toLocaleDateString('id-ID', options);
  };

  const onSearch = () => {};

  const contextState = {
    arr,
    arrJob,
    setArr,
    input,
    setInput,
    setArrJob,
    fetchStatus,
    setFetchStatus,
    selected,
    setSelected,
    dataRadio,
    user,
    setUser,
  };

  const contextFunctions = {
    handleInput,
    handleEdit,
    handleSubmit,
    handleDelete,
    logouthandler,
    renderData,
    showContentTable,
    handleRadioButton,
    showStatus,
    handleDetail,
    showFormattedDate,
    onSearch,
  };

  return (
    <GlobalContext.Provider
      value={{
        contextState,
        contextFunctions,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};
